import { id, root } from './library';

export const library = {
  ...root,
  id: {
    ...id,
  },
};
